
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15.585","height":"9.15"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_30062","data-name":"Group 30062","transform":"translate(-1.129 1.872)"}},[_c('g',{attrs:{"id":"Group_30063","data-name":"Group 30063"}},[_c('g',{attrs:{"id":"Group_30065","data-name":"Group 30065","transform":"translate(0 -1)","fill":"none","stroke":"#96a0ae","stroke-linecap":"round","stroke-width":"1.2"}},[_c('path',{attrs:{"id":"Path_21008","data-name":"Path 21008","d":"M.6 8.3V1.487a.913.913 0 01.419-.815c.313-.166.569-.027.781.258q1.185 1.626 2.368 3.257h0a.373.373 0 00.63 0l.378-.515q1-1.37 1.994-2.741c.2-.278.449-.424.756-.276a.851.851 0 01.445.856v6.727","transform":"translate(1.129 -.82)","stroke-linejoin":"round"}}),_c('g',{attrs:{"id":"Group_30064","data-name":"Group 30064","transform":"translate(-1 -1)"}},[_c('line',{attrs:{"id":"Line_873","data-name":"Line 873","x1":"1.898","y2":"1.898","transform":"translate(14.968 6.533)"}}),_c('line',{attrs:{"id":"Line_874","data-name":"Line 874","x1":"1.898","y1":"1.898","transform":"translate(13.071 6.532)"}}),_c('line',{attrs:{"id":"Line_875","data-name":"Line 875","y1":"7.701","transform":"translate(14.969 .729)"}})])])])])])
          )
        }
      }
    